var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*!--------------------------------------------------------------------------
// <copyright file="GSS.common.ts" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
var GSS;
(function (GSS) {
    var common;
    (function (common) {
        var AuditComponentName;
        (function (AuditComponentName) {
            AuditComponentName.headerValue = "SBT - Legacy";
        })(AuditComponentName = common.AuditComponentName || (common.AuditComponentName = {}));
        /**
            * @description Force to close progressing message pop up.
            */
        function absoluteProgressHide() {
            $(document).on('ajaxStop', function () {
                setTimeout(function () {
                    if ($('[data-dyn-el]').length > 0) {
                        $('[data-dyn-el]').each(function () { this.parentNode.removeChild(this); });
                    }
                }, 300);
            });
        }
        common.absoluteProgressHide = absoluteProgressHide;
        function GetUrlParams(url) {
            var _urlParams = url.split('?')[1];
            var _params = _urlParams.split('&');
            var _pairs = {};
            _params.forEach(function (element) {
                var pair = element.split('=');
                _pairs[pair[0]] = pair[1];
            });
            return _pairs;
        }
        common.GetUrlParams = GetUrlParams;
        function addAntiForgeryToken(data) {
            // <summary>Adds the ASP.NET MVC antiforgery token to an object.</summary>
            // <param name="data">The object that the antiforgery token will be add.</param>
            var _rvt = $('input[name=__RequestVerificationToken]:first').val();
            data = common.extendValue(data, '__RequestVerificationToken', _rvt);
            return data;
        }
        common.addAntiForgeryToken = addAntiForgeryToken;
        function clearField(el) {
            $(el)
                .not(':button, :submit, :reset, :hidden')
                .val('')
                .prop('checked', false)
                .prop('selected', false);
        }
        common.clearField = clearField;
        function clearForm(formId) {
            // <summary>Clears the inputs in a form.</summary>
            // <param name="formId">The id of the form to clear.</param>
            var _form = document.getElementById(formId);
            _form.reset();
            $(':input', '#' + formId)
                .not(':button, :submit, :reset, :hidden')
                .val('')
                .prop('checked', false)
                .prop('selected', false);
            var _elements = $(':input', '#' + formId).children(".selectpicker");
            _elements.each(function () {
                $(this).clear();
            });
            $('.selectpicker').selectpicker('refresh');
            return true;
        }
        common.clearForm = clearForm;
        function encodeAndParameterize(data) {
            var _params = [];
            if (typeof (data) != "object") {
                _params.push(encodeURIComponent(decodeURIComponent(data)));
            }
            else {
                for (var _field in data) {
                    if (data.hasOwnProperty(_field)) {
                        var _param = "";
                        if (typeof (data[_field]) != "object") {
                            _param += _field + "=";
                        }
                        _param += encodeAndParameterize(data[_field]);
                        _params.push(_param);
                    }
                }
            }
            return _params.join("&");
        }
        common.encodeAndParameterize = encodeAndParameterize;
        function extendValue(data, key, value, isNeededEncoding) {
            // <summary>
            // Extends the incoming object with the key value pair specified.  If the data is a string it is appended like a query string.
            //  if the data is an object type, the property will be set on the object.
            // </summary>
            // <param name="data">The data to extend with the new value.</param>
            // <param name="key">The property name to add to the data.</param>
            // <param name="value">The value for the property.</param>
            var _data = data || '';
            var _value = isNeededEncoding == undefined ? value : isNeededEncoding == true ? encodeURIComponent(value) : value;
            if (typeof _data !== 'object') {
                if (_data.length == 0) {
                    _data = key + "=" + _value;
                }
                else if (_data.length > 0 && _data.indexOf(key + "=") == -1) {
                    _data += '&' + key + '=' + _value;
                }
            }
            else if (_data.toString() === '[object FormData]') {
                _data.append(key, value);
            }
            else if (Array.isArray(_data)) {
                _data = $.grep(_data, function (item) { return item != key; });
                _data.push({ name: key, value: _value });
            }
            else {
                if (!_data[key]) {
                    _data[key] = _value;
                }
            }
            return _data;
        }
        common.extendValue = extendValue;
        /**
        * @description Gets the current component name based on the component id in the url.
        * If useParentComponentName is true, then returns the parent component if not null or empty, if not returns the current component name.
        */
        function getCurrentComponentName(useParentComponentName) {
            if (useParentComponentName === void 0) { useParentComponentName = false; }
            var queryParams = new URLSearchParams(window.location.search);
            var componentIdString = queryParams.get('gssComponentId');
            var componentId = null;
            var _component = null;
            var _componentName = '';
            if (componentIdString !== null) {
                componentId = parseInt(componentIdString, 10);
                if (componentId !== null) {
                    _component = GSS.pc.Components.getById(componentId);
                }
            }
            if (componentId == null) {
                componentIdString = queryParams.get('componentDefinitionCodeName');
                if (componentIdString !== null) {
                    _component = GSS.pc.Components.getByCodeName(componentIdString);
                }
            }
            if (_component != null) {
                _componentName = useParentComponentName ? isNotNullOrEmpty(_component.parentComponentName) ? _component.parentComponentName : _component.name : _component.name;
            }
            return _componentName;
        }
        common.getCurrentComponentName = getCurrentComponentName;
        ;
        function getAttributeValue(attributeName, el) {
            // <summary>Gets the specified attribute value.</summary>
            // <param name="attributeName">The name of the attribute to get the value for.</param>
            // <param name="el">An optional parameter that if defined uses the element to get the closest attribute for.</param>
            // If the element is not defined, just use an attribute selector and grab the first instance.
            var _attrEl = null;
            var _selector = '[' + attributeName + ']';
            if (!el) {
                _attrEl = $(_selector + ':first');
            }
            else {
                _attrEl = $(el).closest(_selector);
                if (!_attrEl || _attrEl.length == 0) {
                    _attrEl = $(el).children(_selector + ':first');
                }
            }
            if (_attrEl && _attrEl.length > 0) {
                return _attrEl.attr(attributeName);
            }
            else {
                return null;
            }
        }
        common.getAttributeValue = getAttributeValue;
        function getCookieValue(cookieName) {
            /// <summary>Gets the value of the specified cookie, or null if it doesn't exist.</summary>
            /// <param name="cookieName">The name of the cookie to get a value for.</param>
            /// ***NOTE: if the cookie is HTTPOnly, this doesn't work
            /// ***ALSO if the cookie is chunked it probably won't work
            var _cookies = document.cookie.split('; ');
            var _cookiePair = null;
            for (var i = _cookies.length - 1; i >= 0; i--) {
                _cookiePair = _cookies[i].split('=');
                if (_cookiePair[0] == cookieName) {
                    return _cookiePair[1];
                }
            }
            return null;
        }
        common.getCookieValue = getCookieValue;
        function getParameterByName(name, url) {
            var _url = url == undefined ? location.search : url;
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(_url);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
        common.getParameterByName = getParameterByName;
        function getFunction(fullyQualifiedName) {
            var _returnValue = null;
            var _array = fullyQualifiedName.split('.');
            if (_array.length > 0) {
                var _length = _array.length;
                for (var i = 0; i < _length; ++i) {
                    if (i === 0) {
                        _returnValue = window[_array[i]];
                    }
                    else {
                        _returnValue = _returnValue[_array[i]];
                    }
                }
            }
            return _returnValue;
        }
        common.getFunction = getFunction;
        // this code is used when pagination script is inline
        common.pagination = {
            ids: { pageSizePostFix: '_PageSize' },
            getPageSize: function (identifierPrefix) { return $('#' + identifierPrefix + common.pagination.ids.pageSizePostFix).val(); },
            getPageNumber: function (attributeName) {
                if (attributeName === void 0) { attributeName = null; }
                var _pageNumber;
                if (GSS.common.isNotNullOrEmpty(attributeName)) {
                    _pageNumber = $('.pagination li.active')[0] ? +$('.pagination li.active').find('a').attr(attributeName) : 1;
                }
                else {
                    _pageNumber = $('.pagination li.active')[0] ? +$('.pagination li.active')[0].innerText : 1;
                }
                return _pageNumber;
            }
        };
        // To retrieve pagination following meta data:
        // page number and its attribute page number name
        // page size and its attribute page size name
        // the id that pagination belongs to
        function getPager(gridId) {
            var _pageNumber = $(this).data('gss-page-num') !== undefined && $(this).data('gss-page-num') !== null ? +$(this).data('gss-page-num') : 1;
            var _pageSize = +$(gridId.gssGetId() + '_PageSize').val();
            var _pageNumberName = 'data-gss-name'.gssGetAtt(gridId + '_PageNumber');
            var _pageSizeName = gridId.gssGetId() + '_PageSize';
            return { pageSize: _pageSize, pageNumber: _pageNumber, pageSizeName: _pageSizeName, pageNumberName: _pageNumberName };
        }
        common.getPager = getPager;
        function manageInfo() {
            return __awaiter(this, arguments, void 0, function (clientUserDataKey, clientUserDataJwtKey, timeout, includeJwtToken) {
                var _session, _sessionItem, _diffMili;
                if (clientUserDataKey === void 0) { clientUserDataKey = "__client_user_data"; }
                if (clientUserDataJwtKey === void 0) { clientUserDataJwtKey = '__client_user_data_jwt'; }
                if (timeout === void 0) { timeout = 5; }
                if (includeJwtToken === void 0) { includeJwtToken = false; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _session = new GSS.common.session(true);
                            _sessionItem = _session.getItem(clientUserDataKey);
                            if (!(_sessionItem === undefined || _sessionItem === null)) return [3 /*break*/, 2];
                            return [4 /*yield*/, getInfo(clientUserDataKey, clientUserDataJwtKey, includeJwtToken)];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            _diffMili = new Date().getTime() - new Date(_sessionItem.value).getTime();
                            if (!((_diffMili / 1000 / 60) >= timeout)) return [3 /*break*/, 4];
                            sessionStorage.removeItem(clientUserDataKey);
                            return [4 /*yield*/, getInfo(clientUserDataKey, clientUserDataJwtKey, includeJwtToken)];
                        case 3: return [2 /*return*/, _a.sent()];
                        case 4: return [2 /*return*/, _sessionItem.values];
                    }
                });
            });
        }
        common.manageInfo = manageInfo;
        // Gets the bearer token from portal, upserts the response into the clientUserDataKey in the session storage
        // Gets the full JWT instead of just the reference token.
        function manageInfoJwt() {
            return __awaiter(this, arguments, void 0, function (clientUserDataKey, timeout) {
                var _session, _sessionItem, _diffMili;
                if (clientUserDataKey === void 0) { clientUserDataKey = "__client_user_data_jwt"; }
                if (timeout === void 0) { timeout = 5; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _session = new GSS.common.session(true);
                            _sessionItem = _session.getItem(clientUserDataKey);
                            if (!(_sessionItem === undefined || _sessionItem === null)) return [3 /*break*/, 2];
                            return [4 /*yield*/, getInfoJwt(clientUserDataKey)];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            _diffMili = new Date().getTime() - new Date(_sessionItem.value).getTime();
                            if (!((_diffMili / 1000 / 60) >= timeout)) return [3 /*break*/, 4];
                            return [4 /*yield*/, getInfoJwt(clientUserDataKey)];
                        case 3: return [2 /*return*/, _a.sent()];
                        case 4: return [2 /*return*/, _sessionItem.values];
                    }
                });
            });
        }
        common.manageInfoJwt = manageInfoJwt;
        function refreshTokenAsync() {
            return __awaiter(this, arguments, void 0, function (clientUserDataKey, clientUserDataJwtKey, timeout, sessionIdKey) {
                var _this = this;
                if (clientUserDataKey === void 0) { clientUserDataKey = "__client_user_data"; }
                if (clientUserDataJwtKey === void 0) { clientUserDataJwtKey = '__client_user_data_jwt'; }
                if (timeout === void 0) { timeout = 5; }
                if (sessionIdKey === void 0) { sessionIdKey = "__id_"; }
                return __generator(this, function (_a) {
                    sessionStorage.removeItem(sessionIdKey);
                    window.localStorage.removeItem("expiration");
                    GSS.PortalContainer.refreshAccessToken(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, manageInfo(clientUserDataKey, clientUserDataJwtKey, timeout)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [2 /*return*/];
                });
            });
        }
        common.refreshTokenAsync = refreshTokenAsync;
        function refreshJwtTokenAsync() {
            return __awaiter(this, arguments, void 0, function (clientUserDataKey, timeout) {
                var _this = this;
                if (clientUserDataKey === void 0) { clientUserDataKey = "__client_user_data_jwt"; }
                if (timeout === void 0) { timeout = 5; }
                return __generator(this, function (_a) {
                    sessionStorage.removeItem(clientUserDataKey);
                    GSS.PortalContainer.refreshAccessToken(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, manageInfoJwt(clientUserDataKey, timeout)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [2 /*return*/];
                });
            });
        }
        common.refreshJwtTokenAsync = refreshJwtTokenAsync;
        // Makes the API call to get the JWT token from the API endpoint /BearerToken
        function getInfoJwt(clientUserDataKey) {
            var _session = new GSS.common.session(true);
            var _data = {};
            var _componentId = +GSS.common.getAttributeValue(GSS.widget.attributeNames.componentId, '');
            _data = GSS.pc.Request.setRequiredData(_componentId, _data);
            return $.ajax({
                type: "GET",
                url: '../_Portal/BearerToken',
                data: _data,
                cache: false,
                contentType: "application/json",
                headers: null,
            }).done(function (data) {
                var _clientData = {
                    id: clientUserDataKey,
                    value: new Date().toISOString(),
                    values: { token: data.token, hasStrengths: data.hasStrengths },
                };
                _session.upsert(_clientData);
                return _clientData.values;
            });
        }
        common.getInfoJwt = getInfoJwt;
        function getInfo(clientUserDataKey, clientUserDataJwtKey, includeJwtToken) {
            if (includeJwtToken === void 0) { includeJwtToken = false; }
            var _session = new GSS.common.session(true);
            var _data = {};
            if (includeJwtToken !== undefined) {
                _data['includeJwtToken'] = includeJwtToken;
            }
            var _componentId = +GSS.common.getAttributeValue(GSS.widget.attributeNames.componentId, '');
            _data = GSS.pc.Request.setRequiredData(_componentId, _data);
            return $.ajax({
                type: "GET",
                url: '../_Portal/Token',
                data: _data,
                cache: false,
                contentType: "application/json",
                headers: null,
            }).done(function (data) {
                var _clientData = {
                    id: clientUserDataKey,
                    value: new Date().toISOString(),
                    values: { token: data.token },
                };
                _session.upsert(_clientData);
                if (includeJwtToken) {
                    var _clientDataJwt = {
                        id: clientUserDataJwtKey,
                        value: new Date().toISOString(),
                        values: { token: data.jwtToken, hasStrengths: data.hasStrengths },
                    };
                    _session.upsert(_clientDataJwt);
                }
                if (data.expiration) {
                    window.localStorage.setItem("expiration", data.expiration);
                }
                return _clientData.values;
            });
        }
        common.getInfo = getInfo;
        // every pagination will need two events for page size and page number: onChange and onClick
        // this function will automatically binds the two events to one callback function
        // this function can not be use as a delegate to an element such as $(document).on(.....)
        // this function will only work as function scope level
        function addPaginationListeners(gridId, callback) {
            var _pager = GSS.common.getPager(gridId);
            var _pageNumberName = _pager.pageNumberName;
            var _pageSizeName = _pager.pageSizeName;
            $(_pageSizeName).on('change', { gridId: gridId }, callback);
            $(_pageNumberName).on('click', { gridId: gridId }, callback);
        }
        common.addPaginationListeners = addPaginationListeners;
        function selectAllText(textInputObject) {
            // Deselects all the text first (to prevent cross browser weirdness)
            if (window.getSelection) {
                window.getSelection().removeAllRanges();
            }
            textInputObject.trigger('select');
        }
        common.selectAllText = selectAllText;
        common.scrollBar = {
            _element: function () { return $(GSS.data.constructDataAtt('data-gss-name', 'divWidget')); },
            save: function () {
                $(common.scrollBar._element).data('lastPosition', $(document).scrollTop());
            },
            restore: function () {
                var _position = $(common.scrollBar._element).data('lastPosition');
                GSS.common.wait(150).done(function () { $(document).scrollTop(_position); });
            },
            default: function () { return $(document).scrollTop(0); },
            clear: function () { $(common.scrollBar._element).removeData('lastPosition'); },
        };
        common.tag = {
            attributes: { associatedIdAttributeName: 'data-associated-id' },
            clearInput: function (el, e) {
                // <param name="el">The current element.</param>
                // <param name="e">The current event.</param>
                var _relatedId = $(el).closest('[data-gss-name="tag"]').attr(common.tag.attributes.associatedIdAttributeName);
                if (_relatedId) {
                    common.clearField($('#' + _relatedId));
                }
                return true;
            }
        };
        function parseData(dataToParse, replaceEscape) {
            if (replaceEscape === void 0) { replaceEscape = true; }
            var _parsedData;
            if (replaceEscape)
                _parsedData = JSON.parse('{"' + dataToParse.replace(/&/g, "\",\"").replace(/=/g, "\":\"").replace(/\+/g, " ") + '"}');
            else
                _parsedData = JSON.parse(dataToParse);
            return _parsedData;
        }
        common.parseData = parseData;
        function convertQueryStringToObject(queryString) {
            var _obj = {}, _queries;
            // Split into key/value pairs
            _queries = queryString.split('&');
            // Convert the array of strings into an object
            for (var i = 0; i < _queries.length; i++) {
                var _temp = _queries[i].split('=');
                if (_temp[1] == '' || _temp[1] == undefined) {
                    _obj[_temp[0]] = null;
                }
                else {
                    if (_obj[_temp[0]] == null) {
                        _obj[_temp[0]] = _temp[1];
                    }
                    // This else block is made for the question bank filters where each filter can have multiple values
                    else {
                        if (_obj[_temp[0]] && typeof _obj[_temp[0]] === 'object' && _obj[_temp[0]].constructor === Array) {
                            _obj[_temp[0]].push(_temp[1]);
                        }
                        else {
                            _obj[_temp[0]] = [_obj[_temp[0]], _temp[1]];
                        }
                    }
                }
            }
            return _obj;
        }
        common.convertQueryStringToObject = convertQueryStringToObject;
        function serializeArrayToObject(array) {
            var _o = {};
            $.each(array, function () {
                if (_o[this.name]) {
                    if (!_o[this.name].push) {
                        _o[this.name] = [_o[this.name]];
                    }
                    _o[this.name].push(this.value || '');
                }
                else {
                    _o[this.name] = this.value || '';
                }
            });
            return _o;
        }
        common.serializeArrayToObject = serializeArrayToObject;
        function convertArrayToJson(array) {
            var _obj = new Object();
            if (typeof array == "object") {
                for (var i in array) {
                    var _tmp = convertArrayToJson(array[i]);
                    _obj[i] = _tmp;
                }
            }
            else {
                _obj = array;
            }
            return _obj;
        }
        common.convertArrayToJson = convertArrayToJson;
        ;
        function convertJsonToArray(json) {
            return Object.keys(json).map(function (i) { return json[i]; });
        }
        common.convertJsonToArray = convertJsonToArray;
        function wait(duration) {
            return $.Deferred(function (df) { setTimeout(df.resolve, duration); });
        }
        common.wait = wait;
        function isDigit(val) {
            if (Math.floor(val) == val && (!isNaN(val) && isFinite(val))) {
                return true;
            }
            return false;
        }
        common.isDigit = isDigit;
        function isBool(data) {
            return typeof (data) == typeof (true);
        }
        common.isBool = isBool;
        function getPageName(key) {
            if (key === void 0) { key = 'p'; }
            return GSS.common.getParameterByName(key);
        }
        common.getPageName = getPageName;
        common.responseStatus = { Fail: "Error", Success: "Success" };
        common.returnType = { Html: 'html', Json: 'json', Xml: 'xml', script: 'script', Auto: 'auto' };
        common.modalProgress = { Enable: true, Disable: false };
        function isJson(data) {
            return $.isPlainObject(data);
        }
        common.isJson = isJson;
        function request(url, dataType, cache, timeout, contentType, overrideComponentName) {
            var _this = this;
            if (url === undefined) {
                throw new Error("url is invalid.");
            }
            this._url = url;
            this._cache = cache || false;
            this._dataType = dataType || common.returnType.Html;
            this._ajax = function (requestType, data) {
                if (typeof (data) === 'object' && contentType == 'application/json') {
                    data = JSON.stringify(data);
                }
                var _requestData = {
                    type: requestType,
                    url: this._url,
                    data: data,
                    cache: this._cache,
                    timeout: timeout,
                    headers: requestType === "GET" ? null : { 'X-AuditingComponentName': isNotNullOrEmpty(overrideComponentName) ? overrideComponentName : common.getCurrentComponentName() },
                };
                if (contentType) {
                    _requestData['contentType'] = contentType;
                }
                if (this._dataType !== common.returnType.Auto) {
                    // return ajax object as Promise object for further process
                    _requestData['dataType'] = this._dataType;
                }
                return $.ajax(_requestData);
            };
            var _get = function (data) {
                return _this._ajax("GET", data);
            };
            var _post = function (data) {
                if (data === undefined) {
                    void 0;
                }
                return _this._ajax("POST", data);
            };
            return {
                get: _get,
                post: _post
            };
        }
        common.request = request;
        function isNotNullOrEmpty(val) {
            if ((val === 'undefined') || (val == 0) || (typeof val === 'undefined') || val === null) {
                return false;
            }
            return !((/^\s*$/).test(val));
        }
        common.isNotNullOrEmpty = isNotNullOrEmpty;
        function preCondition(val, parameterName) {
            parameterName = parameterName || "Current value";
            if (!GSS.common.isNotNullOrEmpty(val)) {
                if (((/^\s*$/).test(val))) {
                    val = 'NULL';
                }
                try {
                    throw new Error(parameterName + " is " + val);
                }
                catch (ex) {
                    void 0;
                    return false;
                }
            }
        }
        common.preCondition = preCondition;
        function preConditionElement(attr) {
            if ($(attr).gssElementExists() === false) {
                try {
                    throw new Error(attr + " is not found");
                }
                catch (ex) {
                    void 0;
                    return false;
                }
            }
        }
        common.preConditionElement = preConditionElement;
        function showHelpText(delay) {
            if (delay === void 0) { delay = 600; }
            GSS.common.wait(delay).done(function () {
                $('[data-info-icon="popover"]').each(function () {
                    var $this = $(this);
                    var _val = $this.attr("data-umt-popover");
                    var content = $(this).find('.c-info-icon__content').html();
                    $(this).popover({
                        container: _val ? $this : 'body',
                        trigger: 'hover focus',
                        content: content,
                        html: true
                    });
                });
            });
        }
        common.showHelpText = showHelpText;
        function hideToolTip() {
            $(document).on('keydown', function (e) {
                $(".popover[role='tooltip']").each(function () {
                    if (e.target.hasAttribute("data-umt-popover")) {
                        return;
                    }
                    //hide any open popovers when the anywhere else in the body is clicked
                    if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                        $(this).popover('hide');
                    }
                });
            });
        }
        common.hideToolTip = hideToolTip;
        var session = /** @class */ (function () {
            // set keepAlive = true to keep value/values across pages or components
            // set keepAlive = false, the value/values will only available to the current page or component; it behaves like a hidden field
            // domId: an id of an element
            // attrProp: an attribute property of an element that has id above
            function session(keepAlive, domId, attrProp) {
                this._global = keepAlive || false;
                this._attrRoot = domId || 'wrap'.gssGetId();
                this._attrId = attrProp || '__page_session__';
            }
            session.prototype.add = function (data) {
                var _items = this.getItems();
                if (!this.exist(data)) {
                    _items.push(data);
                }
                if (this._global) {
                    this.__addItems(JSON.stringify(_items));
                }
                else {
                    $(this._attrRoot).data(this._attrId, JSON.stringify(_items));
                }
            };
            session.prototype.update = function (data) {
                if (this.exist(data)) {
                    this.remove(data.id);
                    this.add(data);
                }
            };
            session.prototype.remove = function (id) {
                var _items = this.getItems();
                _items = $.grep(_items, function (o) { return o.id != id; });
                if (this._global) {
                    this.__addItems(JSON.stringify(_items));
                }
                else {
                    $(this._attrRoot).data(this._attrId, JSON.stringify(_items));
                }
            };
            session.prototype.upsert = function (data) {
                if (this.exist(data)) {
                    this.update(data);
                }
                else {
                    this.add(data);
                }
            };
            session.prototype.clear = function () {
                if (this._global) {
                    this.__clearItems();
                }
                else {
                    $(this._attrRoot).removeData(this._attrId);
                }
            };
            session.prototype.exist = function (data) {
                var _obj = this.getItem(data.id);
                return _obj !== undefined;
            };
            session.prototype.getItem = function (id) {
                var _result;
                var _items = this.getItems();
                if (_items.length > 0) {
                    _items.forEach(function (v, i) { if (v.id === id)
                        _result = v; });
                }
                return _result;
            };
            session.prototype.getItems = function () {
                var _result = [];
                var _objString;
                if (this._global) {
                    _objString = this.__getItems();
                }
                else {
                    _objString = $(this._attrRoot).data(this._attrId);
                }
                if (GSS.common.isNotNullOrEmpty(_objString)) {
                    var _jsonObject = JSON.parse(_objString);
                    if (_jsonObject !== null) {
                        _result = GSS.common.convertJsonToArray(_jsonObject);
                    }
                }
                return _result;
            };
            session.prototype.__getItems = function () {
                return sessionStorage.getItem(this.__getKey);
            };
            session.prototype.__addItems = function (value) {
                sessionStorage.setItem(this.__getKey, value);
            };
            session.prototype.__clearItems = function () {
                sessionStorage.removeItem(this.__getKey);
            };
            Object.defineProperty(session.prototype, "__getKey", {
                get: function () {
                    var _key = '__id_';
                    var _id = GSS.data.getValueByProp('data-gss-clientid') !== undefined ? (GSS.data.getValueByProp('data-gss-clientid')).toString() : _key;
                    if (sessionStorage.getItem(_key) !== undefined) {
                        _id = _key;
                    }
                    return _id;
                },
                enumerable: false,
                configurable: true
            });
            return session;
        }());
        common.session = session;
        var memoryStorage = /** @class */ (function () {
            function memoryStorage(id) {
                this._id = id.gssGetId();
                this._attr = '__in_m_s__' + id;
            }
            memoryStorage.prototype.get = function () {
                if (typeof $(this._id).data(this._attr) !== 'undefined') {
                    return $(this._id).data(this._attr).toString();
                }
                else {
                    return '';
                }
            };
            memoryStorage.prototype.getArray = function () {
                if (typeof $(this._id).data(this._attr) !== 'undefined') {
                    return this.get().split(',');
                }
                else {
                    return [];
                }
            };
            memoryStorage.prototype.set = function (v) {
                $(this._id).data(this._attr, v);
            };
            memoryStorage.prototype.add = function (v) {
                var _objs = this.getArray();
                // role id already exist
                if ($.inArray(v, _objs) == -1) {
                    _objs.push(v);
                    this.set(_objs.toString());
                }
            };
            memoryStorage.prototype.remove = function (v) {
                // not implement
            };
            memoryStorage.prototype.exist = function (v) {
                //not implement
            };
            return memoryStorage;
        }());
        common.memoryStorage = memoryStorage;
        var localStorage = /** @class */ (function () {
            function localStorage(hiddenFieldId) {
                this._id = hiddenFieldId.gssGetId();
            }
            // return a array
            localStorage.prototype.getArray = function () {
                if ($(this._id).length > 0 && $(this._id).val().length > 0) {
                    return $(this._id).val().split(',');
                }
                else {
                    return [];
                }
            };
            // return a string
            localStorage.prototype.get = function () {
                if ($(this._id).length > 0 && $(this._id).val().length > 0) {
                    return $(this._id).val();
                }
                else {
                    return '';
                }
            };
            // override existing value
            localStorage.prototype.set = function (v) {
                $(this._id).val(v);
            };
            // only add new value if it doesn't exist
            localStorage.prototype.add = function (v) {
                var _roleIds = this.getArray();
                // role id already exist
                if ($.inArray(v, _roleIds) == -1) {
                    _roleIds.push(v);
                    $(this._id).val(_roleIds.toString());
                }
            };
            // only remove value if it exists
            localStorage.prototype.remove = function (v) {
                var _roleIds = this.getArray();
                // role id found
                if ($.inArray(v, _roleIds) > -1) {
                    _roleIds.splice($.inArray(v, _roleIds), 1);
                    $(this._id).val(_roleIds.toString());
                }
            };
            // check if a value exists
            localStorage.prototype.exist = function (v) {
                var _roleIds = this.getArray();
                // role id found
                if ($.inArray(v, _roleIds) > -1) {
                    return true;
                }
                return false;
            };
            return localStorage;
        }());
        common.localStorage = localStorage;
        var shortMem = /** @class */ (function () {
            function shortMem(key) {
                this._id = key;
                this._prop = GSS.data.constructIdAtt('wrap');
            }
            shortMem.prototype.get = function () {
                if ($(this._prop).gssElementExists()) {
                    if (GSS.common.isNotNullOrEmpty($(this._prop).data(this._id))) {
                        var _data = $(this._prop).data(this._id);
                        return JSON.stringify(_data);
                    }
                }
                return '';
            };
            shortMem.prototype.getArray = function () {
                return JSON.parse(this.get());
            };
            shortMem.prototype.set = function (v) {
                if ($(this._prop).gssElementExists()) {
                    $(this._prop).data(this._id, v);
                }
            };
            shortMem.prototype.clear = function () {
                if ($(this._prop).gssElementExists()) {
                    $(this._prop).removeData(this._id);
                }
            };
            return shortMem;
        }());
        common.shortMem = shortMem;
        // generate letter and number
        function getUniqueId() {
            return Math.random().toString(36).substr(2, 10);
        }
        common.getUniqueId = getUniqueId;
        // only support one grid at a time. Make sure to call this function after the grid is finish rendering
        function addReturnVoidToGridPageNumbers(gridId) {
            var _attr = '[data-page-number-id=' + gridId + '_PageSize] a';
            $(_attr).each(function () { $(this).prop('href', 'javascript:void(0)'); });
        }
        common.addReturnVoidToGridPageNumbers = addReturnVoidToGridPageNumbers;
        // support either one or more grids and don't have to worry about if the grid is finish rendering
        function addReturnVoidToAllGridPageNumber() {
            var gridId = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                gridId[_i] = arguments[_i];
            }
            $(document).on('ajaxStop', function () {
                gridId.forEach(function (v, i) {
                    addReturnVoidToGridPageNumbers(v);
                });
            });
        }
        common.addReturnVoidToAllGridPageNumber = addReturnVoidToAllGridPageNumber;
        var singleDimensionArray;
        (function (singleDimensionArray) {
            function add(array, item) {
                array = array || [];
                if (!GSS.common.singleDimensionArray.exist(array, item)) {
                    array.push(item);
                }
            }
            singleDimensionArray.add = add;
            function remove(array, item) {
                array = array || [];
                array = $.grep(array, function (v) { return v !== item; });
                return array;
            }
            singleDimensionArray.remove = remove;
            function exist(array, item) {
                array = array || [];
                if (array === undefined)
                    return false;
                var _count = array.length;
                while (_count--) {
                    var _item = array[_count];
                    if (_item == item) {
                        return true;
                    }
                }
                return false;
            }
            singleDimensionArray.exist = exist;
        })(singleDimensionArray = common.singleDimensionArray || (common.singleDimensionArray = {}));
        var groupFilter;
        (function (groupFilter) {
            var _functions = [];
            var _selectedData = [];
            var _tier1PageIndex, _tier2PageIndex;
            var _pageIndex = [];
            var _pageId, _pageAttr;
            var _defaultTextAttr = 'data-default-text';
            var _noResultTextAttr = 'data-no-result-text';
            function attachEventsToControls(attrId, isFirst) {
                if (isFirst === void 0) { isFirst = true; }
                var tierSelects = document.querySelectorAll('[data-tier-select]');
                Array.prototype.forEach.call(tierSelects, function (tSelect) {
                    var selectToggle = tSelect.querySelector('.c-tier-select__toggle');
                    var template = tSelect.getAttribute('data-choice-template') || " selected";
                    var emptyMsg = tSelect.getAttribute('data-choice-empty') || selectToggle.textContent;
                    var category = tSelect.querySelector('.c-tier-select__label');
                    if (isFirst) {
                        // Open toggle
                        selectToggle.addEventListener('click', function (e) {
                            tSelect.querySelector('.c-tier-select__selection').classList.toggle('is-open');
                        });
                        // Close when click outside
                        window.addEventListener('click', function (e) {
                            if (tSelect.contains(e.target)) {
                                e.stopPropagation();
                            }
                            else {
                                tSelect.querySelector('.c-tier-select__selection').classList.remove('is-open');
                            }
                        });
                    }
                    var tiers = [];
                    var tierChoices = [];
                    Array.prototype.forEach.call(tSelect.querySelectorAll('[data-tier]'), function (tierEl) {
                        var tier = parseInt(tierEl.getAttribute('data-tier'), 10);
                        tiers[tier - 1] = tier;
                    });
                    Array.prototype.forEach.call(tSelect.querySelectorAll('input[type=checkbox],input[type=radio]'), function (el) {
                        el.removeEventListener('change', function (e) {
                        });
                    });
                    Array.prototype.forEach.call(tSelect.querySelectorAll('input[type=checkbox],input[type=radio]'), function (el) {
                        el.addEventListener('change', function (e) {
                            makeSelection(el);
                        });
                    });
                    function makeSelection(target) {
                        var checked = target.checked;
                        var multiple = target.getAttribute('type') == 'checkbox';
                        var tier = parseInt(target.parentElement.parentElement.getAttribute('data-tier'), 10);
                        var parent = tSelect.querySelector('[data-tier="' + tier + '"]');
                        if (multiple) {
                            tierChoices[tier - 1] = [];
                            Array.prototype.forEach.call(parent.querySelectorAll('[data-tier="' + tier + '"] input[type=checkbox]:checked'), function (el) {
                                tierChoices[tier - 1].push(el);
                            });
                        }
                        else {
                            tierChoices[tier - 1] = target;
                        }
                        if (checked && tier !== tiers[tiers.length - 1]) {
                            parent.classList.add('has-selection');
                            parent.classList.remove('is-active');
                        }
                        else {
                            parent.classList.remove('has-selection');
                        }
                        ;
                        if (tier !== tiers[tiers.length - 1]) {
                            tSelect.querySelector('[data-tier="' + (tier + 1) + '"]').classList.add('is-active');
                        }
                        else {
                            var _currentId = ($(target).parents(_pageAttr).gssData(_pageId)).toString();
                            var _item = util.get(_functions, _currentId);
                            if (_item.isSingleSelection) {
                                tSelect
                                    .querySelector('.c-tier-select__selection')
                                    .classList
                                    .remove('is-open');
                            }
                        }
                    }
                    tSelect.removeEventListener('click', function (e) { });
                    // Handle all inside clicks
                    tSelect.addEventListener('click', function (e) {
                        if (e.target.classList.contains('c-tier-select__back-link')) {
                            var tier = parseInt(e.target.parentElement.parentElement.getAttribute('data-tier'), 10);
                            var parent = tSelect.querySelector('[data-tier="' + tier + '"]');
                            Array.prototype.forEach.call(parent.querySelectorAll('input:checked'), function (el) {
                                el.checked = false;
                            });
                            Array.prototype.forEach.call(tSelect.querySelectorAll('[data-tier="' + (tier - 1) + '"] input:checked'), function (el) {
                                el.checked = false;
                            });
                            tSelect.querySelector('[data-tier="' + tier + '"]').classList.remove('is-active');
                            tSelect.querySelector('[data-tier="' + (tier - 1) + '"]').classList.add('is-active');
                            tierChoices = tierChoices.slice(0, tier - 2);
                        }
                        ;
                    });
                });
            }
            groupFilter.attachEventsToControls = attachEventsToControls;
            function intitialize() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                GSS.common.groupFilter.attachEventsToControls.call(this);
                if (args.length > 0) {
                    args.forEach(function (v, i) {
                        _pageId = (v.idProp === undefined || v.idProp === null) ? 'data-gss-group-filter-id' : v.idProp;
                        _pageAttr = _pageId.gssGetAtt();
                        var _functionItem = {
                            id: v.id,
                            value: {
                                actionFunction: v.actionFunction || null,
                                itemFunction: v.itemFunction || null,
                                goBackFunction: v.goBackFunction || null,
                                id: v.id || null,
                                pageSize: v.pageSize || 5,
                                pageIndex: 2,
                                resetFirstTier: v.resetFirstTier,
                                isSingleSelection: v.isSingleSelection || false
                            }
                        };
                        // save each object to a array.
                        groupFilter.util.add(_functions, _functionItem);
                        // initialize page number for each control and all its tiers
                        // currently only support 2 tiers
                        _pageIndex.push({ id: v.id, tier: 1, pageNumber: 2 });
                        _pageIndex.push({ id: v.id, tier: 2, pageNumber: 2 });
                        var _attr = _pageId.gssGetAtt(_functionItem.id);
                        var _isMulti = $(_attr).find('[data-tier]').length > 1;
                        $(_attr).find('[data-tier]').each(function () {
                            var _tier = $(this).data('tier');
                            var _active = $(this).hasClass('is-active');
                            // bind event to inner items
                            if (_tier === 1) {
                                _tier1PageIndex = 2;
                                attachItemHandler.call(this, _functionItem.value.itemFunction, _tier, _isMulti, _functionItem.value.pageSize, true, _functionItem.value.isSingleSelection);
                            }
                            attachSearchHandler.call(this, _functionItem.value.actionFunction, _tier, _functionItem.value.pageSize);
                            attachLoadMoreHandler.call(this, _functionItem.value.actionFunction, _tier, _functionItem.value.pageSize);
                            attachPreviousHandler.call(this, _functionItem.value.goBackFunction, _functionItem.value.actionFunction, _functionItem.value.pageSize, _functionItem.value.resetFirstTier);
                        });
                    });
                }
            }
            groupFilter.intitialize = intitialize;
            function attachItemHandler(fn, tier, isMulti, pageSize, showLoadMore, isSingleSelection) {
                if (fn === void 0) { fn = null; }
                var _cb = fn !== null ? GSS.common.getFunction(fn) : $.noop;
                var _currentId = ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                var _attr = _pageId.gssGetAtt(_currentId);
                // get message from data attribute
                var _nullMsg = ($(_attr).gssData(_noResultTextAttr)) !== undefined ? ($(_attr).gssData(_noResultTextAttr)).toString() : null;
                // generate id for empty message
                var _id = _currentId + '_emptyMsg';
                if ($(this).children('.c-tier-select__option').length > 0) {
                    // always remove empty result message at first time
                    $(this).find(_id.gssGetId()).remove();
                    //show load more button at first time
                    if (showLoadMore) {
                        $(this).find('.c-tier-select__more').gssRemoveClass('hidden');
                    }
                    else {
                        $(this).find('.c-tier-select__more').gssAddClass('hidden');
                    }
                    // bind event to inner items
                    $(this).children('.c-tier-select__option').each(function () {
                        $(this).on('change', function () {
                            var _currentId = ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                            var _el = $(this).find('input[type=checkbox],input[type=radio]');
                            var _text = _el.next('label').text();
                            var _tier = $(this).parents('[data-tier]').data('tier');
                            var _search = $(this).parents('[data-tier]').children('.c-tier-select__search').find('input[type=search]');
                            var _searchText = _search.val();
                            if (_el.is(':checked')) {
                                if (isSingleSelection) {
                                    GSS.common.groupFilter.util.filterArray.clear(_currentId);
                                }
                                GSS.common.groupFilter.util.filterArray.add({ value: _el.val(), attrId: _currentId, text: _text, tier: _tier });
                            }
                            else {
                                _selectedData = GSS.common.groupFilter.util.filterArray.remove({ value: _el.val(), attrId: _currentId, text: _text, tier: _tier });
                            }
                            var _data = {
                                selected: _el.is(':checked'),
                                selectedValues: GSS.common.groupFilter.util.filterArray.get(_currentId),
                                tier: tier,
                                value: _el.val(),
                                currentId: _currentId
                            };
                            util.displaySelectedValues.call(this);
                            _cb.call(this, _data);
                        });
                    });
                }
                // no items, show empty result message and hide load more button
                else {
                    $(this).find('.c-tier-select__more').gssAddClass('hidden');
                    var _initEl = $(this).find('div.c-tier-select__search');
                    $('<p/>').attr({ 'id': _id, 'class': 'c-tier-select__label' }).append(_nullMsg).insertAfter(_initEl);
                }
            }
            groupFilter.attachItemHandler = attachItemHandler;
            function detachItemHandler() {
                $(this).children('.c-tier-select__option').each(function () {
                    $(this).off('change');
                });
            }
            groupFilter.detachItemHandler = detachItemHandler;
            function attachSearchHandler(fn, tier, pageSize) {
                if (fn === void 0) { fn = null; }
                var _cb = fn !== null ? GSS.common.getFunction(fn) : $.noop;
                var _currentId = ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                $(this).children('.c-tier-select__search').find('input[type=search]').on('keydown', function (event) {
                    var _this = this;
                    if (event.keyCode == 13) {
                        var _data = {
                            element: $(this),
                            isSearch: true,
                            pageNumber: 1,
                            pageSize: pageSize,
                            searchText: $(this).val(),
                            tier: tier,
                            currentId: _currentId
                        };
                        util.resetPageIndex(_currentId, tier);
                        $(document).on('ajaxStop', function () {
                            restoreSelection.call(_this, _currentId);
                        });
                        _cb.call(this, _data);
                    }
                });
            }
            groupFilter.attachSearchHandler = attachSearchHandler;
            function attachLoadMoreHandler(fn, tier, pageSize) {
                if (fn === void 0) { fn = null; }
                var _cb = fn !== null ? GSS.common.getFunction(fn) : $.noop;
                var _searchEl = $(this).children('.c-tier-select__search').find('input[type=search]');
                $(this).children('.c-tier-select__more').find('a').on('click', function (event) {
                    var _currentId = ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                    var _obj = util.get(_functions, _currentId);
                    var _data = {
                        element: $(this),
                        isSearch: false,
                        pageNumber: util.getPageIndex(_currentId, tier),
                        pageSize: pageSize,
                        searchText: _searchEl.val(),
                        tier: tier,
                        currentId: _currentId
                    };
                    util.IncrementPageIndex(_currentId, tier);
                    util.updateById(_functions, _obj, _currentId);
                    $(this).closest('.c-tier-select__more').gssAddClass('hidden');
                    _cb.call(this, _data);
                });
            }
            groupFilter.attachLoadMoreHandler = attachLoadMoreHandler;
            function attachPreviousHandler(fn, searchFn, pageSize, resetFirstTier) {
                if (fn === void 0) { fn = null; }
                var _searchFn = fn !== null ? GSS.common.getFunction(searchFn) : $.noop;
                var _cb = fn !== null ? GSS.common.getFunction(fn) : $.noop;
                $(this).children('.c-tier-select__back').find('a').on('click', function (event) {
                    var _currentId = ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                    _selectedData = groupFilter.util.filterArray.clear(_currentId);
                    // clear search text box
                    $('.c-tier-select__search').find('input[type=search]').each(function () {
                        if (resetFirstTier) {
                            //clear all search data on all tiers
                            $(this).val('');
                        }
                        else {
                            // keep first tier search value
                            var _tier = $(this).parents('[data-tier]').data('tier');
                            if (_tier > 1) {
                                $(this).val('');
                            }
                        }
                    });
                    if (resetFirstTier) {
                        // reset page number index for tier 1
                        util.resetPageIndex(_currentId, 1);
                    }
                    // reset page number index for tier 2
                    util.resetPageIndex(_currentId, 2);
                    util.displaySelectedValues.call(this);
                    // clear first tier search's value
                    if (resetFirstTier) {
                        var _data = {
                            element: $(this),
                            isSearch: true,
                            pageNumber: 1,
                            pageSize: pageSize,
                            searchText: null,
                            tier: 1,
                            currentId: _currentId
                        };
                        _searchFn.call(this, _data);
                    }
                    _cb.call(this);
                });
            }
            groupFilter.attachPreviousHandler = attachPreviousHandler;
            function setContent(result, data) {
                var _resultCount = $($.parseHTML(result)).filter('.c-tier-select__option').length;
                var _currentId = data.currentId || ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                var _attr = _pageId.gssGetAtt(_currentId);
                var _nullMsg = ($(_attr).gssData(_noResultTextAttr)).toString();
                var _showLoadMore = true;
                $(_attr).find('[data-tier]').each(function () {
                    // only work on active section
                    if ($(this).hasClass('is-active')) {
                        var _item = util.get(_functions, _currentId);
                        // no more items to show, hide load more button
                        if (_resultCount === 0 || _resultCount < _item.pageSize) {
                            _showLoadMore = false;
                            $(this).find('.c-tier-select__more').gssAddClass('hidden');
                        }
                        // show load more button
                        else {
                            _showLoadMore = true;
                            $(this).find('.c-tier-select__more').gssRemoveClass('hidden');
                        }
                        // we want to clear previous results when search for new item
                        if (data.isSearch) {
                            $(this).find('div.c-tier-select__option').remove();
                        }
                        // generate id for empty message
                        var _id = _currentId + '_emptyMsg';
                        // always remove empty result message at first time
                        $(this).find(_id.gssGetId()).remove();
                        // add empty message, if no results.
                        if (_resultCount === 0) {
                            var _lastEl = $(this).find('div.c-tier-select__option');
                            if (_lastEl.length === 0) {
                                var _initEl = $(this).find('div.c-tier-select__search');
                                $('<p/>').attr({ 'id': _id, 'class': 'c-tier-select__label' }).append(_nullMsg).insertAfter(_initEl);
                            }
                        }
                        // append results
                        else if (result !== null) {
                            var _lastEl = $(this).find('div.c-tier-select__option').last();
                            if (_lastEl.length > 0) {
                                $(result).insertAfter(_lastEl);
                            }
                            else {
                                var _initEl = $(this).find('div.c-tier-select__search');
                                $(result).insertAfter(_initEl);
                            }
                            // detach/reattach events
                            GSS.common.groupFilter.detachItemHandler.call(this);
                            GSS.common.groupFilter.attachEventsToControls.call(this, _currentId, false);
                            GSS.common.groupFilter.attachItemHandler.call(this, _item.itemFunction, $(this).data('tier'), false, _item.pageSize, _showLoadMore, _item.isSingleSelection);
                        }
                    }
                });
            }
            groupFilter.setContent = setContent;
            function getDefaultFunctionData(attrId, tier) {
                if (tier === void 0) { tier = 1; }
                var _data = {
                    isSearch: true,
                    pageNumber: 1,
                    pageSize: 5,
                    searchText: null,
                    currentId: attrId,
                    tier: tier
                };
                return _data;
            }
            groupFilter.getDefaultFunctionData = getDefaultFunctionData;
            function clearFilters() {
                var clearElementIds = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    clearElementIds[_i] = arguments[_i];
                }
                // clear desired controls
                clearElementIds.forEach(function (v, i) {
                    $("input:text").each(function () {
                        var _clearId = $(this).prop('id') || $(this).attr('id');
                        if (_clearId === v) {
                            $(this).val('');
                        }
                    });
                    $("input:hidden").each(function () {
                        var _clearId = $(this).prop('id') || $(this).attr('id');
                        if (_clearId === v) {
                            $(this).val('');
                        }
                    });
                });
                $('.c-tier-select__option').each(function () {
                    var _el = $(this).find('input[type=checkbox],input[type=radio]');
                    if (_el.is(':checked')) {
                        _el.prop('checked', false);
                    }
                });
                // clear data
                _selectedData = [];
                var _ids = _pageId.gssGetAtt();
                $(_ids).each(function () {
                    var _currentId = ($(this).gssData(_pageId)).toString();
                    _selectedData = groupFilter.util.filterArray.clear(_currentId);
                    util.displaySelectedValues.call(this, _selectedData, _currentId);
                });
                // clear search textbox
                $('.c-tier-select__search').find('input[type=search]').each(function () {
                    $(this).val('');
                });
                // reset multi tier filter
                $('[data-tier="2"]').each(function () { $(this).gssRemoveClass('is-active'); });
                $('[data-tier="1"]').each(function () { $(this).gssAddClass('is-active'); });
                // reload the first set
                _functions.forEach(function (v, i) {
                    if (v.value.actionFunction !== undefined && v.value.actionFunction !== null) {
                        var _cb = GSS.common.getFunction(v.value.actionFunction) || $.noop;
                        var _data = {
                            isSearch: true,
                            pageNumber: 1,
                            pageSize: v.value.pageSize,
                            searchText: '',
                            tier: 1,
                            currentId: v.id
                        };
                        _cb.call(this, _data);
                    }
                });
            }
            groupFilter.clearFilters = clearFilters;
            function restoreSelection(attrId) {
                var _attr = _pageId.gssGetAtt(attrId);
                $(_attr).find('[data-tier]').each(function () {
                    if ($(this).hasClass('is-active')) {
                        $(this).find('div.c-tier-select__option').each(function () {
                            var _el = $(this).find('input[type=checkbox],input[type=radio]');
                            var _text = _el.next('label').text();
                            var _value = _el.val();
                            _el.prop('checked', util.filterArray.itemExist(_value));
                        });
                    }
                });
            }
            groupFilter.restoreSelection = restoreSelection;
            var util;
            (function (util) {
                function getDOMSelectedValues(attrId) {
                    if ((attrId !== null) && (attrId !== undefined)) {
                        var _attr = _pageId.gssGetAtt(attrId);
                        var _textBits = $(_attr).data('textBits');
                        if ((_textBits !== null) && (_textBits !== undefined)) {
                            return _textBits;
                        }
                    }
                    return [];
                }
                util.getDOMSelectedValues = getDOMSelectedValues;
                function saveDOMSelectedValues(attrId, value) {
                    if ((attrId !== null) && (attrId !== undefined)) {
                        var _attr = _pageId.gssGetAtt(attrId);
                        $(_attr).data('textBits', value);
                    }
                }
                util.saveDOMSelectedValues = saveDOMSelectedValues;
                function getPageIndex(id, tier) {
                    var _pageNumber = -1;
                    if (_pageIndex.length > 0) {
                        _pageIndex.forEach(function (v, i) {
                            if ((v.id === id) && (v.tier === tier)) {
                                _pageNumber = v.pageNumber;
                            }
                        });
                    }
                    return _pageNumber;
                }
                util.getPageIndex = getPageIndex;
                function IncrementPageIndex(id, tier) {
                    var _pageNumber = -1;
                    if (_pageIndex.length > 0) {
                        _pageIndex.forEach(function (v, i) {
                            if ((v.id === id) && (v.tier === tier)) {
                                var _newPageNumber = v.pageNumber + 1;
                                var _newObj = { id: v.id, tier: v.tier, pageNumber: _newPageNumber };
                                _pageIndex.splice(i, 1);
                                _pageIndex.push(_newObj);
                                _pageNumber = _newPageNumber;
                                // cheat the devil to exit for each loop
                                tier = -1;
                            }
                        });
                    }
                    return _pageNumber;
                }
                util.IncrementPageIndex = IncrementPageIndex;
                function resetPageIndex(id, tier) {
                    var _pageNumber = -1;
                    if (_pageIndex.length > 0) {
                        _pageIndex.forEach(function (v, i) {
                            if ((v.id === id) && (v.tier === tier)) {
                                var _newPageNumber = 2;
                                var _newObj = { id: v.id, tier: v.tier, pageNumber: _newPageNumber };
                                _pageIndex.splice(i, 1);
                                _pageIndex.push(_newObj);
                                _pageNumber = _newPageNumber;
                                // cheat the devil to exit for each loop
                                tier = -1;
                            }
                        });
                    }
                    return _pageNumber;
                }
                util.resetPageIndex = resetPageIndex;
                function exist(array, item) {
                    var _count = array.length;
                    while (_count--) {
                        var _item = array[_count];
                        if (_item.id === item.id) {
                            return true;
                        }
                    }
                    return false;
                }
                util.exist = exist;
                function add(array, item) {
                    if (!GSS.common.groupFilter.util.exist(array, item)) {
                        array.push(item);
                    }
                }
                util.add = add;
                function get(array, id) {
                    var obj = $.grep(array, function (obj) { return obj.id === id; })[0];
                    if (obj !== null) {
                        return obj.value;
                    }
                    else
                        return null;
                }
                util.get = get;
                function remove(array, id) {
                    array = $.grep(array, function (o) { return o.id != id; });
                    return array;
                }
                util.remove = remove;
                function updateById(array, newObj, id) {
                    util.remove(array, id);
                    util.add(array, { id: id, value: newObj });
                }
                util.updateById = updateById;
                function displaySelectedValues(array, attrId) {
                    var _currentId = attrId || ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                    var _result = array || _selectedData;
                    var _array = filterArray.getItems(_currentId);
                    var _attrId = _pageId.gssGetAtt(_currentId);
                    var _templateText = $(_attrId).data('choice-template');
                    var _defaultText = ($(_attrId).gssData(_defaultTextAttr)).toString();
                    var _tierCount = $(_attrId).find('[data-tier]').length;
                    var _count = _array.length || 0;
                    var _tierSelected = _count - 1;
                    if (_tierCount > 1) {
                        if (_count === 1) {
                            _defaultText = _array[0].text;
                        }
                        else if (_count === 2) {
                            _defaultText = _array[0].text + ' > ' + _array[1].text;
                        }
                        else if (_count > 2) {
                            _defaultText = _array[0].text + ' > ' + _tierSelected + ' ' + _templateText.trim();
                        }
                    }
                    else {
                        if (_count === 1) {
                            _defaultText = _array[0].text;
                        }
                        else if (_count > 1) {
                            var _singleTierSelectedCount = _tierSelected + 1;
                            _defaultText = _singleTierSelectedCount + ' ' + _templateText.trim();
                        }
                    }
                    $('.c-tier-select__toggle').each(function () {
                        var _id = ($(this).parents(_pageAttr).gssData(_pageId)).toString();
                        if (_id === _currentId) {
                            $(this).text(_defaultText);
                        }
                    });
                }
                util.displaySelectedValues = displaySelectedValues;
                var filterArray;
                (function (filterArray) {
                    function add(item) {
                        if (!GSS.common.groupFilter.util.filterArray.exist(item)) {
                            _selectedData.push(item);
                        }
                    }
                    filterArray.add = add;
                    function remove(item) {
                        var _result = [];
                        _selectedData.forEach(function (v, i) {
                            // from different filter
                            if (v.attrId !== item.attrId) {
                                _result.push(v);
                            }
                            // same filter
                            else {
                                // different tier
                                if (v.tier !== item.tier) {
                                    _result.push(v);
                                }
                                else if (v.value !== item.value) {
                                    _result.push(v);
                                }
                            }
                        });
                        return _result;
                    }
                    filterArray.remove = remove;
                    function getItemText(attrId, value) {
                        var _text = null;
                        _selectedData.forEach(function (v, i) {
                            if ((v.attrId === attrId) && (v.value === value)) {
                                _text = v.text;
                            }
                        });
                        return _text;
                    }
                    filterArray.getItemText = getItemText;
                    function exist(item) {
                        var _count = _selectedData.length;
                        while (_count--) {
                            var _item = _selectedData[_count];
                            if ((_item.attrId == item.attrId) && (_item.value == item.value)) {
                                return true;
                            }
                        }
                        return false;
                    }
                    filterArray.exist = exist;
                    function get(attrId) {
                        var _array = [];
                        _selectedData.forEach(function (v, i) {
                            if (v.attrId === attrId) {
                                GSS.common.singleDimensionArray.add(_array, v.value);
                            }
                        });
                        return _array;
                    }
                    filterArray.get = get;
                    function removeAllSecondTierData(attrId) {
                        var _result = [];
                        _selectedData.forEach(function (v, i) {
                            // from different filter
                            if (v.attrId !== attrId) {
                                _result.push(v);
                            }
                            // same filter
                            else {
                                if (v.tier === 1) {
                                    _result.push(v);
                                }
                            }
                        });
                        _selectedData = _result;
                        return _result;
                    }
                    filterArray.removeAllSecondTierData = removeAllSecondTierData;
                    function getItems(attrId) {
                        var _array = [];
                        _selectedData.forEach(function (v, i) {
                            if (v.attrId === attrId) {
                                _array.push(v);
                            }
                        });
                        return _array;
                    }
                    filterArray.getItems = getItems;
                    function clear(attrId) {
                        var _result = [];
                        _selectedData.forEach(function (v, i) {
                            if (v.attrId !== attrId) {
                                _result.push(v);
                            }
                        });
                        _selectedData = _result;
                        return _result;
                    }
                    filterArray.clear = clear;
                    function itemExist(value) {
                        var _found = false;
                        _selectedData.forEach(function (v, i) {
                            if (v.value === value) {
                                _found = true;
                            }
                        });
                        return _found;
                    }
                    filterArray.itemExist = itemExist;
                    function print() {
                        void 0;
                    }
                    filterArray.print = print;
                })(filterArray = util.filterArray || (util.filterArray = {}));
            })(util = groupFilter.util || (groupFilter.util = {}));
        })(groupFilter = common.groupFilter || (common.groupFilter = {}));
        function attributeDisabled($element) {
            var _attributeDisabled = false;
            if (($element !== null) && ($element !== undefined)) {
                _attributeDisabled = $element.is('[disabled=disabled]');
            }
            return _attributeDisabled;
        }
        common.attributeDisabled = attributeDisabled;
        var Event = /** @class */ (function () {
            function Event() {
                var _this = this;
                this.subscribe = function (method) {
                    _this.observers.push(method);
                };
                this.notify = function (arg) {
                    for (var _i = 0, _a = _this.observers; _i < _a.length; _i++) {
                        var observer = _a[_i];
                        observer(arg);
                    }
                };
                this.observers = [];
            }
            return Event;
        }());
        common.Event = Event;
    })(common = GSS.common || (GSS.common = {}));
    var data;
    (function (data) {
        /// <summary>Save value to existing data attribute.</summary>;
        /// <summary>Notice: key is a data attribute property must already exist in order to have it works</summary>;
        function set(key, value) {
            common.preCondition(value, "value");
            common.preCondition(key, "key");
            if (common.isJson(value) == false) {
                throw new Error("value is not json object");
            }
            var _$el = $(constructDataAtt(key.prop, key.val));
            _$el.data(constructDataAtt(key.prop, key.val), value);
        }
        data.set = set;
        function get(key) {
            GSS.common.preCondition(key, "key");
            var _$el = $(constructDataAtt(key.prop, key.val));
            return _$el.data(constructDataAtt(key.prop, key.val));
        }
        data.get = get;
        // Get the first valid attribute value
        function getValueFromParent($element, prop) {
            var _returnValue;
            if (prop.indexOf('data') !== -1) {
                prop = prop.replace('data-', '');
            }
            $element.parents().each(function () {
                if (typeof $(this).data(prop) !== 'undefined') {
                    _returnValue = $(this).data(prop);
                }
            });
            return _returnValue;
        }
        data.getValueFromParent = getValueFromParent;
        function constructDataAtt(prop, val) {
            var _result;
            common.preCondition(prop, "data attribute property");
            if (common.isNotNullOrEmpty(val)) {
                _result = "[" + prop + "='" + val + "']";
            }
            else {
                _result = "[" + prop + "]";
            }
            return _result;
        }
        data.constructDataAtt = constructDataAtt;
        function constructIdAtt(id) {
            var _result;
            common.preCondition(id, "id for current element");
            _result = "[id = " + id + "]";
            return _result;
        }
        data.constructIdAtt = constructIdAtt;
        function getElementByData(prop, val) {
            var _el = constructDataAtt(prop);
            if (prop.indexOf('data') !== -1) {
                prop = prop.replace('data-', '');
            }
            if (!common.isNotNullOrEmpty(val)) {
                return $(_el).filter(function () { return typeof $(this).data(prop) !== 'undefined'; });
            }
            return $(_el).filter(function () { return $(this).data(prop) == val; });
        }
        data.getElementByData = getElementByData;
        function getValueByProp(prop) {
            var _el = constructDataAtt(prop);
            return $(_el).gssData(prop);
        }
        data.getValueByProp = getValueByProp;
    })(data = GSS.data || (GSS.data = {}));
    var responseStatus;
    (function (responseStatus) {
        responseStatus[responseStatus["Success"] = 1] = "Success";
        responseStatus[responseStatus["Error"] = 2] = "Error";
        responseStatus[responseStatus["ClientOutOfSync"] = 3] = "ClientOutOfSync";
    })(responseStatus = GSS.responseStatus || (GSS.responseStatus = {}));
    /// <summary>This module is intended for debugging purpose only.</summary>;
    var debug;
    (function (debug_1) {
        var debug = true;
        var _style = {
            debugStyle: [, 'color: Blue', 'display: block', 'text-align: left'].join(';'),
            infoStyle: [, 'color: gray', 'display: block', 'text-align: left'].join(';'),
            warningStyle: [, 'color: Coral', 'display: block', 'text-align: left'].join(';'),
            objectStyle: [, 'color: CornflowerBlue', 'display: block', 'text-align: left'].join(';'),
        };
        function _log(data, style) {
            if (data.indexOf("&") != -1) {
                data = data.replace(/\n|\r/g, "");
                var _ar = data.split(':');
                var _obj = GSS.common.convertQueryStringToObject(_ar[1].trim());
                data = JSON.stringify(_obj, null, '\t');
            }
            if (debug) {
                if (navigator.userAgent.indexOf("Chrome") != -1) {
                    switch (style) {
                        case 1:
                            void 0;
                            break;
                        case 2:
                            void 0;
                            break;
                        case 3:
                            void 0;
                            break;
                        default:
                            void 0;
                            break;
                    }
                }
                else {
                    switch (style) {
                        case 1:
                        case 2:
                            // showRequestInfo need to set to false to have it print out
                            // GSS.debug.showRequestInfo(false);
                            void 0;
                            break;
                        case 3:
                            void 0;
                            break;
                        default:
                            void 0;
                            break;
                    }
                }
            }
        }
        var ObjectHelper = /** @class */ (function () {
            function ObjectHelper(obj) {
                this.obj = obj;
            }
            ObjectHelper.prototype.IsObject = function () {
                var type = typeof this.obj;
                return type === 'function' || type === 'object' && !!this.obj;
            };
            ObjectHelper.prototype.Print = function () {
                var result = "";
                if (this.IsObject()) {
                    for (var index in this.obj) {
                        result += index + ': ' + this.obj[index] + '\n';
                    }
                }
                return result;
            };
            return ObjectHelper;
        }());
        ;
        function clearConsole() {
            /*Remarks: Should use for debugging purpose only. This will will clear annoying build up console.log window's content*/
            if (typeof console._commandLineAPI !== 'undefined') {
                console.API = console._commandLineAPI;
            }
            else if (typeof console._inspectorCommandLineAPI !== 'undefined') {
                console.API = console._inspectorCommandLineAPI;
            }
            else if (typeof console.clear !== 'undefined') {
                console.API = console;
            }
            console.API.clear();
        }
        debug_1.clearConsole = clearConsole;
        function consoleSupress(debug) {
            var originConsole = console;
            var suppress = debug || false;
            if (suppress) {
                //console.info('%c ' + 'console is off', infoStyle);
                var methods = ["log", "debug", "warn", "info", "dir", "dirxml", "trace", "profile"];
                for (var i = 0; i < methods.length; i++) {
                    console[methods[i]] = function () { };
                }
            }
            else {
                console = originConsole;
            }
        }
        debug_1.consoleSupress = consoleSupress;
        function showRequestInfo(disable, raw, showVersion) {
            debug = disable;
            raw = raw || false;
            var originConsole = console;
            if (disable) {
                if (showVersion) {
                    _log('Version: ' + $().jquery, 2);
                    _log('console.log is off, use console.info or console.warn instead.', 2);
                }
                $(document).on('ajaxStart', function () {
                    void 0;
                    void 0;
                });
                $(document).on('ajaxStop', function () {
                    void 0;
                    void 0;
                });
                $(document).on('ajaxError', function (event, jqxhr, ajaxOptions, errorThrown) {
                    var contentType = jqxhr.getResponseHeader("Content-Type");
                    var responseBody = jqxhr.responseText;
                    $('[data-dyn-el]').each(function () { this.parentNode.removeChild(this); });
                    try {
                        throw new Error("ERROR !!!!!!");
                    }
                    catch (ex) {
                        void 0;
                        return false;
                    }
                });
                $(document).on('ajaxSend', function (event, jqxhr, settings) {
                    if (raw) {
                        void 0;
                        void 0;
                        void 0;
                        void 0;
                        void 0;
                    }
                    if (settings.url.indexOf('?') !== -1) {
                        var _tmp = settings.url.split('?');
                        void 0;
                        GSS.debug.log(_tmp[1], 1);
                        void 0;
                    }
                    else {
                        GSS.debug.log(settings.url, 1);
                    }
                });
                console.log = function () { };
            }
            else {
                console = originConsole;
            }
        }
        debug_1.showRequestInfo = showRequestInfo;
        function log() {
            var arg = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                arg[_i] = arguments[_i];
            }
            var i;
            var msg = "";
            var number = (arg.length > 1) ? arg[arg.length - 1] : 0;
            var style;
            if (GSS.common.isDigit(number)) {
                style = number;
            }
            for (i = 0; i < arg.length; ++i) {
                var obj = new ObjectHelper(arg[i]);
                if (obj.IsObject()) {
                    msg = msg + '\r\n' + typeof obj + ':\r\n' + JSON.stringify(obj, null, '\t');
                }
                else {
                    if (i == arg.length - 1) {
                        if (!GSS.common.isDigit(arg[i])) {
                            msg = msg + '\r\n' + typeof arg[i] + ': ' + arg[i];
                        }
                    }
                    else {
                        msg = msg + '\r\n' + typeof arg[i] + ': ' + arg[i];
                    }
                }
            }
            _log(msg, style);
        }
        debug_1.log = log;
    })(debug = GSS.debug || (GSS.debug = {}));
})(GSS || (GSS = {}));
$(document).on('click', function (arg) {
    var _$self = $(arg.target);
    var _autoDisableAttributeName = 'gss-auto-disable';
    var _enableAutoDisable = (function () {
        if (_$self.data(_autoDisableAttributeName) !== undefined) {
            var _data = _$self.data(_autoDisableAttributeName);
            if (GSS.common.isBool(_data)) {
                return _data;
            }
        }
        return false;
    }());
    if (!_enableAutoDisable) {
        return;
    }
    var _disableIntervalAttributeName = 'gss-disable-interval';
    var _duration = (function () {
        if (_$self.data(_disableIntervalAttributeName) !== undefined) {
            var _data = _$self.data(_disableIntervalAttributeName);
            if (GSS.common.isDigit(_data)) {
                return parseInt(_data);
            }
            else {
                return -1;
            }
        }
    }());
    _$self.gssAutoDisable({ duration: _duration, inputTypes: ['button', 'a'] });
});
$(document).on('submit', function (arg) {
    var _$self = $(arg.target);
    var _autoDisableAttributeName = 'gss-auto-disable';
    var _enableAutoDisable = (function () {
        if (_$self.data(_autoDisableAttributeName) !== undefined) {
            var _data = _$self.data(_autoDisableAttributeName);
            if (GSS.common.isBool(_data)) {
                return _data;
            }
        }
        return false;
    }());
    if (!_enableAutoDisable) {
        return;
    }
    var _disableIntervalAttributeName = 'gss-disable-interval';
    var _duration = (function () {
        if (_$self.data(_disableIntervalAttributeName) !== undefined) {
            var _data = _$self.data(_disableIntervalAttributeName);
            if (GSS.common.isDigit(_data)) {
                return parseInt(_data);
            }
            else {
                return -1;
            }
        }
    }());
    _$self.gssAutoDisable({ duration: _duration, inputTypes: ['form'] });
});
$(document).on("keypress", function (e) {
    var _$el = $(".__page_name");
    if (_$el.length) {
        //shift + '+' for show/hide
        if (e.which === 43 && event.shiftKey) {
            _$el.toggle();
        }
    }
});
$(document).on('ajaxStop', function () {
    var _padding = $('body').find('padding-right');
    if ((typeof _padding !== 'undefined') && (_padding)) {
        $('body').css('padding-right', 0);
    }
});
// following are extend functions
String.prototype.gssGetId = function () {
    var _newVal = this.replace('#', '').trim();
    return '#' + _newVal;
};
String.prototype.gssGetAtt = function (prop) {
    if (GSS.common.isNotNullOrEmpty(prop)) {
        return GSS.data.constructDataAtt(this, prop);
    }
    else {
        return GSS.data.constructDataAtt(this);
    }
};
String.prototype.gssToString = function () {
    if (GSS.common.isNotNullOrEmpty(this)) {
        return this.toString();
    }
    return null;
};
String.prototype.gssEncode = function () {
    if ((this !== null) && (this !== undefined)) {
        return encodeURI(this);
    }
};
String.prototype.gssHashCode = function () {
    var hash = 0, i = 0, len = this.length;
    while (i < len) {
        var _code = this.charCodeAt(i++);
        //ignore space
        if (_code !== 32) {
            hash = ((hash << 5) - hash + _code) << 0;
        }
    }
    return hash;
};
Array.prototype.gssSort = function () {
    var _arr = this;
    _arr.sort(function (a, b) {
        var nameA = a.Name.toUpperCase(); // ignore upper and lowercase
        var nameB = b.Name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // names must be equal
        return 0;
    });
    return _arr;
};
// set it to false, false when check in
GSS.debug.showRequestInfo(false, false);
//# sourceMappingURL=GSS.common.js.map